import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import dataR from '../../data/cidr3.json';

const DuplicateSimilarityHistogram = () => {
    //3_duplicate_similarity_scores
    const data = dataR.map(d => d.Similarity);


    if (!Array.isArray(data) || data.length === 0) {
        return <div>Loading chart...</div>;
    }

    // Create histogram bins
    const binCount = 10;
    const min = Math.min(...data);
    const max = Math.max(...data);
    const binSize = (max - min) / binCount;
    const bins = new Array(binCount).fill(0);

    data.forEach(score => {
        const index = Math.min(Math.floor((score - min) / binSize), binCount - 1);
        bins[index]++;
    });

    const xLabels = bins.map((_, i) =>
        `${(min + i * binSize).toFixed(2)} - ${(min + (i + 1) * binSize).toFixed(2)}`
    );

    const option = {
        title: {
            text: 'Distribution of Similarity Scores',
            left: 'center',
            textStyle: {
                fontSize: window.innerWidth <= 668 ? 12 : 18,
                overflow: 'truncate', // or use 'break' if wrapping manually
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: ({ 0: { name, value } }) => `${name}<br/>Count: ${value}`,
        },
        xAxis: {
            type: 'category',
            data: xLabels,
            name: 'Similarity',
            axisLabel: {
                rotate: 45,
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            },
            nameLocation: 'middle',
            nameGap: 60,
        },
        yAxis: {
            type: 'value',
            name: 'Count',
            //nameLocation: 'middle',
            //nameGap: 30,
            axisLabel: {
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            }
        },
        grid: {
            left: '2%',
            right: '10%',
            bottom: '15%',
            top: '15%',
            containLabel: true,
        },
        series: [
            {
                type: 'bar',
                data: bins,
                itemStyle: {
                    color: '#6366f1',
                },
            },
        ],
    };

    return (
        <div className="border-2 border-gray-300 rounded-lg p-4 bg-white dark:bg-black shadow">
            <ReactECharts option={option} style={{ height: 400 }} />
        </div>
    );
};

export default DuplicateSimilarityHistogram;
